<template>
  <div class="about">
    <div class="banner">
      <div class="enTitle">Hello ,ConTech universe</div>
      <div class="zhTitle">内容营销未来式</div>
    </div>
    <div
      class="header_banner"
      v-scroll="scrollHeader"
      :style="animate.header.bannerStyle"
    ></div>
    <div class="context">
      <img
        src="https://respool.isheji.com/isheji/static/qiye/image/about/about.png"
      />
      <div class="item">
        <div class="title">关于我们</div>
        <div class="desc">
          <section>爱设计，是一家 AIGC 数字科技企业，国内最早研发「内容中台」解决方</section>
          <section>案的公司之一。致力于帮助企业实现内容全链路（生产、管理、分发、数</section>
          <section>据）的数字化升级。在 AI+办公领域，爱设计推出首款AI办公产品AiPPT.cn，</section>
          <section>AiPPT.cn 致力于为用户提供更加高效、便捷的演示工具，助力用户在各</section>
          <section>种场景下展示自己的创意和想法。</section>
        </div>
        <div class="desc">
          <section>曾先后获得⼼元资本、微梦传媒、视觉中国、信天创投、策源创投、亚杰基</section>
          <section>金、神策数据的投资，为汽车、食品饮料、美妆、日化、鞋服、数码3C、金</section>
          <section>融、教育等领域的500+头部企业提供了完整的内容数字化解决方案。</section>
        </div>
        <div class="desc">
          <section>爱设计核心团队成员来自腾讯、字节跳动、百度、电通等全球一线互联网</section>
          <section>及4A公司，拥有“技术+创意”的双重基因和多年企业级服务经验，致力于</section>
          <section>构建数字化营销时代下的内容新基建。</section>
        </div>
      </div>
    </div>
    <div class="lab">
      <div class="content">
        <div class="title">
          <img
            src="https://respool.isheji.com/isheji/static/qiye/image/home/lab.svg"
          />
        </div>
        <div class="tips">在内容科技的宇宙探索中，我们从未停止</div>
        <div class="desc">
          <section>
            爱设计ConTech AI Lab致力于实践“科技驱动内容营销更高效”的理念，
          </section>
          <section>也是爱设计内容中台的底层核心力量支撑</section>
        </div>
        <router-link target="_blank" to="/lab">
          <div class="button">
            立即体验
            <i class="el-icon-right"></i>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="lab_banner"
      v-scroll="scrollLab"
      :style="animate.lab.bannerStyle"
    ></div>
    <div class="chart">
      <div class="title">荣誉资质</div>
      <img src="https://respool.isheji.com/isheji/static/qiye/image/about/honor.png" alt="" style="width:100%;">
    </div>
    <div class="culture">
      <div class="title">企业文化</div>
      <div class="cultrue-wrap">
        <div
          v-for="item in cultureList"
          :key="item.id"
          class="item"
          :style="{backgroundImage: 'url(' + item.imgUrl + ')', backgroundSize:'contain'}"
         >
          <div class="name">{{ item.name }}</div>
          <div v-for="text in item.text" class="text">{{ text }}</div>
        </div>
      </div>
    </div>
    <div class="opportunity">
      <div class="title">工作机会</div>
      <div class="desc">
        我们崇尚专注热爱的事业，更加尊重自由奔放的个性，在这里，我们以一种体现自我价值的态度存在。
      </div>
      <div class="button" @click="goContact">加入我们</div>
    </div>
  </div>
</template>
<script>
import 'animate.css'
export default {
  name: 'HomeView',
  data() {
    return {
      animate: {
        header: {
          bannerStyle: {
            top: '60'
          }
        },
        lab: {
          bannerStyle: {
            top: '2040'
          }
        }
      },
      cultureList: [{
        id: 1,
        name: '愿景',
        text: ['最值得信赖的内容数字化伙伴'],
        imgUrl: 'https://respool.isheji.com/isheji/static/qiye/image/about/culture_1.png'
      }, {
        id: 2,
        name: '使命',
        text: ['内容科技驱动增长'],
        imgUrl: 'https://respool.isheji.com/isheji/static/qiye/image/about/culture_2.png'
      }, {
        id: 3,
        name: '价值观',
        text: ['客户第一 追求卓越', '相信专业 拥抱变化', '言出必行 共同成长'],
        imgUrl: 'https://respool.isheji.com/isheji/static/qiye/image/about/culture_3.png'
      }]
    }
  },
  created() {},

  methods: {
    scrollLab: function (evt, el) {
      if (window.scrollY > 1020 && window.scrollY < 1140) {
        el.setAttribute('style', 'top:' + (2040 - window.scrollY) + 'px')
      }
    },
    scrollHeader: function (evt, el) {
      el.setAttribute('style', 'top:' + (60 - window.scrollY) + 'px')
    },
    goContact() {
      window.open(
        'https://app.mokahr.com/social-recruitment/microdreams/44523#/',
        '_blank'
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.header_banner {
  position: absolute;
  top: 60px;
  background-image: url('https://respool.isheji.com/isheji/static/qiye/image/contech/animate.png');
  background-repeat: no-repeat;
  background-size: 987px 692px;
  background-position-y: -60px;
  min-width: 1400px;
  background-position-x: 100%;
  width: 100%;
  height: 692px;
  z-index: 2;
}
.lab {
  width: 100%;
  min-width: 1400px;
  height: 594px;
  background: #030000;
  z-index: 2;
  .content {
    width: 1200px;
    z-index: 14;
    position: absolute;
    left: calc((100% - 1200px) / 2);
    .title {
      padding-top: 145px;
      img {
        width: 241px;
        height: 67px;
      }
    }
    .tips {
      margin-top: 24px;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 28px;
    }
    .desc {
      margin-top: 48px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #929296;
      line-height: 22px;
    }
    .button {
      margin-top: 48px;
      width: 126px;
      height: 44px;
      background: #5a2df5;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
      cursor: pointer;
      .el-icon-right {
        display: none;
      }
      &:hover {
        .el-icon-right {
          display: block;
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }
}
.lab_banner {
  position: absolute;
  top: 1020px;
  background-image: url('https://respool.isheji.com/isheji/static/qiye/image/home/lab_banner.png');
  background-repeat: no-repeat;
  background-size: 1208px 714px;
  background-position-y: 0;
  min-width: 1400px;
  background-position-x: 100%;
  width: 100%;
  height: 714px;
}
.banner {
  background-image: url(https://respool.isheji.com/isheji/static/qiye/image/contech/banner.png);
  width: 100%;
  min-width: 1400px;
  height: 460px;
  background-size: 1920px 460px;
  background-position-x: center;
  position: relative;
  padding-top: 148px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .enTitle {
    font-size: 45px;
    font-family: LitSans-Medium, LitSans;
    font-weight: 500;
    color: #ffffff;
    line-height: 56px;
    margin-bottom: 27px;
    width: 1330px;
  }
  .zhTitle {
    font-size: 59px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 82px;
    letter-spacing: 14px;
    width: 1330px;
  }
}
.context {
  width: 100%;
  min-width: 1400px;
  height: 628px;
  position: relative;
  z-index: 1;
  background: #030000;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-right: 85px;
    width: 578px;
    height: 496px;
  }
  .item {
    text-align: left;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 45px;
    }
    .desc {
      margin-top: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
    }
  }
}
.chart {
  // height: 583px;
  width: 100%;
  min-width: 1400px;
  position: relative;
  padding-top: 80px;
  text-align: center;
  background-color: #030000;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 45px;
    position: absolute;
    top: 80px;
  }
}
.culture{
  height: 480px;
  background-color: #030000;
  text-align: center;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    padding-top: 80px;
    padding-bottom: 56px;
  }
  .cultrue-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
  }
  .item {
    width: 384px;
    height: 196px;
    img {
      width: 100%;
    }
    .name {
      color: #fff;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin-top: 70px;
      padding-bottom: 16px;
    }
    .text {
      color: #fff;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      padding-bottom: 4px;
    }
    &:last-child {
      .name {
        margin-top: 49px;
      }
    }
  }
}
.opportunity {
  background-image: url('https://respool.isheji.com/isheji/static/qiye/image/about/opportunity.png');
  background-repeat: no-repeat;
  background-color: #030000;
  background-size: 1920px 350px;
  background-position-x: center;
  width: 100%;
  min-width: 1400px;
  height: 350px;
  padding-top: 74px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 45px;
  }
  .desc {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    margin-top: 32px;
    margin-bottom: 48px;
  }
  .button {
    width: 128px;
    height: 48px;
    border-radius: 4px;
    border: 1px solid #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
    cursor: pointer;
    &:hover {
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #ffffff;
      color: #3b3946;
    }
  }
}
</style>
